import facebook from "@assets/redesign/social/facebook.svg";
import linkedin from "@assets/redesign/social/linkedin.svg";
import telegram from "@assets/redesign/social/telegram.svg";
import x from "@assets/redesign/social/x.svg";
import styles from "./Layout.module.scss";

function Social() {
  return (
    <div className={styles.social}>
      {/*<a href='' target='_blank'>
        <img src={telegram} />
      </a>
      <a href='' target='_blank'>
        <img src={x} />
      </a>
      <a href='' target='_blank'>
        <img src={linkedin} />
      </a>
      <a href='' target='_blank'>
        <img src={facebook} />
      </a>*/}
    </div>
  );
}

export { Social };
